export const API_HOST =
  process.env.REACT_APP_API_HOST || new Error('API_HOST not set');
